import { css } from '@emotion/react';
import { White } from '@constants/color';

export const textContainer = css({
  marginBottom: 60,
  textAlign: 'center'
});

export const text = css({
  fontSize: 48,
  fontWeight: 700,
  lineHeight: '130%',
  color: White.White10
});
